import React from 'react';

export const getRandomIndex = (arrayLength) => Math.floor(Math.random() * arrayLength);

export const defaultUserImages = [
    '/v1525721195/userImages/blurred-avatar-01.webp',
    '/v1525721195/userImages/blurred-avatar-02.webp',
    '/v1525721196/userImages/blurred-avatar-03.webp',
    '/v1525721196/userImages/blurred-avatar-04.webp',
    '/v1525721195/userImages/blurred-avatar-05.webp',
    '/v1525721195/userImages/blurred-avatar-06.webp',
    '/v1525721195/userImages/blurred-avatar-07.webp',
    '/v1525721195/userImages/blurred-avatar-08.webp',
    '/v1525721196/userImages/blurred-avatar-09.webp',
    '/v1525721196/userImages/blurred-avatar-11.webp',
    '/v1525721196/userImages/blurred-avatar-12.webp',
    '/v1525721197/userImages/blurred-avatar-13.webp',
    '/v1525721196/userImages/blurred-avatar-14.webp',
    '/v1525721196/userImages/blurred-avatar-15.webp',
    '/v1525721197/userImages/blurred-avatar-16.webp',
    '/v1525721197/userImages/blurred-avatar-17.webp',
    '/v1525721197/userImages/blurred-avatar-18.webp',
    '/v1525721197/userImages/blurred-avatar-19.webp',
    '/v1525721197/userImages/blurred-avatar-20.webp',
    '/v1525721198/userImages/blurred-avatar-21.webp',
    '/v1525721198/userImages/blurred-avatar-22.webp',
    '/v1525721196/userImages/blurred-avatar-23.webp',
    '/v1525721197/userImages/blurred-avatar-24.webp',
    '/v1525721198/userImages/blurred-avatar-25.webp',
    '/v1525721198/userImages/blurred-avatar-26.webp',
    '/v1525721198/userImages/blurred-avatar-27.webp',
    '/v1525721198/userImages/blurred-avatar-28.webp',
    '/v1525721198/userImages/blurred-avatar-29.webp',
    '/v1525721198/userImages/blurred-avatar-30.webp',
    '/v1525721198/userImages/blurred-avatar-31.webp',
    '/v1525721199/userImages/blurred-avatar-32.webp',
    '/v1525721198/userImages/blurred-avatar-33.webp',
    '/v1525721199/userImages/blurred-avatar-34.webp',
    '/v1525721199/userImages/blurred-avatar-35.webp',
    '/v1525721199/userImages/blurred-avatar-36.webp',
    '/v1525721199/userImages/blurred-avatar-37.webp',
];

const MYSTERY_WOMAN_IMAGE_PATH = '/v1/avatar_black_160_vtg7lw.svg';

export const truncateWithEllipsis = (text, length, ellipses = true) => {
    if (!text || text.length < length) {
        return text;
    }

    const truncated = text.substr(0, length);
    const splitWord = truncated.split(' ');
    if (splitWord.length > 1) {
        delete splitWord[splitWord.length - 1];
    }
    return ellipses
        ? `${splitWord.join(' ').trim()}...`
        : `${splitWord.join(' ')}`;
};

export const removeTagsFromString = (text) => {
    if (text && typeof text === 'string' && text !== '') {
        const tagsRegex = /(?:<(?:!|\/?[a-zA-Z]+).*?\/?>)/;
        const replacedText = text.replace(/<\/p>/gm, '\n');
        return replacedText.split(tagsRegex).join('');
    }
    return text;
};

export const removeTagsFromStringNoPagagaphBreaks = (text) => {
    if (text && text !== '') {
        const tagsRegex = /(?:<(?:!|\/?[a-zA-Z]+).*?\/?>)/;
        return text.split(tagsRegex).join('');
    }
    return text;
};

/**
 * utility function for Employer Marketing's Pricing page
 */
export const getTableHeader = () => [
    {
        label: 'PROGRAM OFFERINGS',
        value: 'PROGRAM OFFERINGS',
    },
    {
        label: 'SILVER',
        value: 'SILVER',
    },
    {
        label: 'GOLD',
        value: 'GOLD',
    },
    {
        label: 'PLATINUM',
        value: 'PLATINUM',
    },
];

/**
 * end
 */

export const videoTypes = {
    YOUTUBE: 'youtube',
    CLOUDINARY: 'cloudinary',
};

export const getVideoType = (videoSrc = '') => {
    if (!videoSrc) {
        return null;
    }

    if (videoSrc.indexOf('youtube') >= 0 || videoSrc.indexOf('youtu.be') >= 0) {
        return videoTypes.YOUTUBE;
    }

    return videoTypes.CLOUDINARY;
};

export function intToMonth(int, short = false) {
    // eslint-disable-next-line no-param-reassign
    if (typeof int === 'string') int = parseInt(int, 10);
    if (int === 0) {
        return null;
    }

    if (short) {
        return [
            null,
            'Jan',
            'Feb',
            'March',
            'April',
            'May',
            'June',
            'July',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ][int];
    }

    return [
        null,
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ][int];
}

/*
    @TODO - there is duplication here with the author serializer on the server.
    Once the server's serializer is refactored, we should update this code
    so that both the server and client use a shared function to serialize a user -MSH050120
*/
export const reserializeAuthor = (author, isAnon, session) => {
    if (isAnon) {
        return {
            ...author,
            userId: null,
            username: 'Anonymous',
            image: {
                alt: 'Anonymous image',
                src: defaultUserImages[
                    getRandomIndex(defaultUserImages.length)
                ],
            },
            credential: null,
            karmaScore: null,
        };
    }

    return {
        ...author,
        userId: session.id,
        username: session.username,
        image: {
            alt: `${session.username} image`,
            src: session.baseLogo || MYSTERY_WOMAN_IMAGE_PATH,
        },
        credential: session.credential,
        karmaScore: session.karma_score,
    };
};

export const linkify = (str) => {
    let match;
    const RE_URL = /\w+:\/\/\S+/g;
    const results = [];
    let lastIndex = 0;
    // eslint-disable-next-line no-cond-assign
    while ((match = RE_URL.exec(str))) {
        const link = match[0];
        if (lastIndex !== match.index) {
            const text = str.substring(lastIndex, match.index);
            results.push(<span key={results.length}>{text}</span>);
        }
        results.push(
            // eslint-disable-next-line react/jsx-no-target-blank
            <a key={results.length} href={link} target="_blank">
                {link}
            </a>
        );
        lastIndex = match.index + link.length;
    }
    if (results.length === 0) {
        return str;
    }
    if (lastIndex !== str.length) {
        results.push(
            <span key={results.length}>{str.substring(lastIndex)}</span>
        );
    }
    return results;
};

const boldSection = (initSection) => {
    const section = initSection.replace(/\n/gm, ' \n ');
    const parts = section.split(/^.*?[.!?\n\r](?:\s|$)/gs);
    if (parts.length > 1) {
        const trueLength = section.length - parts[1].length - 1;
        // Currently converting this h1 for better SEO,
        // if we use user custom formatting in the future we need to refactor this
        parts[0] = <h1>{section.substring(0, trueLength)}</h1>;
    }
    return parts;
};

export const boldify = (text) => {
    if (typeof text === 'string') {
        return boldSection(text);
    }
    if (Array.isArray(text)) {
        const parts = text;
        if (text[0].type === 'span') {
            const updateSection = boldSection(text[0].props.children);
            parts.shift();
            return updateSection.concat(parts);
        }
    }
    return text;
};

export const truncateAndLinkifyCommentContent = (text, length) => {
    // Small text go straight forward
    if (text.length < length) {
        return false;
    }

    // Normal text with no tags
    if (!text.includes('<p>')) {
        return truncateWithEllipsis(text, length, false);
    }

    const tokens = removeTagsFromString(text).split(' ');
    let remainingChars = length;
    let commentPrefix = '';
    let resultantContent = [];
    for (let i = 0; i < tokens.length; i += 1) {
        const token = tokens[i];
        if (token.length > remainingChars) {
            if (token.startsWith('http://') || token.startsWith('https://')) {
                // Last token is a link that will be truncated
                resultantContent = commentPrefix && commentPrefix !== ''
                    ? linkify(commentPrefix.trim())
                    : [];
                const truncatedLink = (
                    <>
                        <span> </span>
                        <a
                            className="truncated-link"
                            href={token}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {`${truncateWithEllipsis(
                                token,
                                remainingChars,
                                false
                            )}`}
                        </a>
                    </>
                );
                if (Array.isArray(resultantContent)) {
                    resultantContent.push(truncatedLink);
                } else {
                    resultantContent = [`${resultantContent} `, truncatedLink];
                }
            } else {
                // No link truncation, just add regular text and linkify
                commentPrefix += truncateWithEllipsis(
                    token,
                    remainingChars,
                    false
                );
                resultantContent = commentPrefix && commentPrefix !== ''
                    ? linkify(commentPrefix.trim())
                    : [];
            }
            break;
        } else {
            commentPrefix += ` ${token}`;
            remainingChars -= token.length + 1;
            if (i === tokens.length - 1) {
                resultantContent = linkify(commentPrefix.trim());
            }
        }
    }
    return resultantContent;
};
